import React from 'react';

import { flagStyles } from '../settings';

const SvgZM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5880px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgZM;
